import React, { useCallback, useState, FormEvent } from 'react';
import { FiMail, FiAlertCircle } from 'react-icons/fi';
import { Link } from 'gatsby';
import Input from '../../Input/Input';
import Button from '../../Button';
import { useAuth } from '../../../hooks/auth';
import { ErrorMessage, SignHeadText } from '../../../styles/globalStyled';
import { checkCpf, cleanCpf } from '../../../utils/validations/cpf';
import { SignupText, Form } from '../styles';
import { useModal } from '../../../hooks/modal';

const EmailSignIn: React.FC = () => {
  const [user, setUser] = useState('');
  const [error, setError] = useState('');
  const [validUser, setValidUser] = useState(false);
  const [isCpf, setIsCpf] = useState(false);
  const { loading, handleLogin } = useAuth();
  const { handleModal } = useModal();

  const handleInputChange = useCallback(async (userLogin) => {
    const { userFormatted, hasCpf } = checkCpf(userLogin);
    setIsCpf(hasCpf);
    setUser(userFormatted);
    setValidUser(true);
  }, []);

  const sendUser = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      setError('');
      try {
        const userData = isCpf ? { cpf: cleanCpf(user) } : { email: user };
        handleLogin(userData, isCpf);
      } catch (err) {
        setError(err.message);
        setValidUser(false);
      }
    },
    [user, isCpf, handleLogin],
  );

  const closeModal = () => {
    handleModal({ isOpen: false, action: '' });
  };

  return (
    <>
      <SignHeadText>
        <label>Seja bem-vindo!</label>
        <p>Insira seu e-mail para entrar:</p>
      </SignHeadText>
      <Form onSubmit={sendUser}>
        <Input
          name="user"
          type="text"
          placeholder="E-mail"
          width="full"
          value={user}
          onChangeValue={handleInputChange}
        />
        <ErrorMessage visibility={error ? 1 : 0}>
          <FiAlertCircle size={20} />
          {error}
        </ErrorMessage>
        <Button
          title="Entrar"
          disabled={!validUser}
          classType="big fat green center topspace"
          loading={loading}
          type="submit"
        />

        <SignupText>
          Ainda não faz parte?{' '}
          <Link to="/register" onClick={closeModal}>
            Criar conta.
          </Link>
        </SignupText>
      </Form>
    </>
  );
};

export default EmailSignIn;
